import React, { useEffect } from "react";
import CloseModalIcon from "../../../shared-components/icons/CloseModalIcon";
import PostalExpand from "../../../shared-components/postalExpand";
import SubscriptionPackages from "@/app/(general-header)/botb-pass/subscriptionPackages";
import { useAppDispatch } from "../../../redux/hooks";
import { publishModalVisibility } from "../../../redux/features/modal/modalSlice";

const SubscriptionPlansModal = ({ place = "" }: { place?: string }) => {
  const dispatch = useAppDispatch();
  const onClose = () => {
    dispatch(publishModalVisibility({ isOpen: false }));
  };
  useEffect(() => {
    document.querySelector("body").classList.add("!overflow-hidden");

    return () => {
      document.querySelector("body").classList.remove("!overflow-hidden");
    };
  }, []);

  return (
    <>
      <div data-name="Overlay" className="fixed inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col m-auto"}>
          <div
            className={
              "bg-gray-4 font-jost relative w-full lg:max-w-[1144px] pt-10 pb-3 lg:pb-6 flex flex-col max-lg:grow lg:rounded-lg"
            }>
            <button className={"absolute right-2 top-2"} onClick={onClose}>
              <CloseModalIcon className={"size-6 text-gray-5"} />
            </button>
            <div className="lg:overflow-y-auto lg:max-h-[902px] lg:pr-2 custom-scrollbar">
              <div className={"lg:max-w-[1032px] lg:mx-auto"}>
                <div className={"text-center mb-4 flex-center flex-col"}>
                  <div className={"text-dark-1 font-semibold text-xl leading-6.5 mb-2"}>
                    One ticket, every competition
                  </div>
                  <div className={"text-sm text-secondary leading-5 font-normal max-w-48"}>
                    Our <span className={"text-primary font-medium"}>members save up to 75%*</span> by playing with BOTB
                    Pass.
                  </div>
                </div>

                <div className={"mb-6"}>
                  <SubscriptionPackages place={place} isUpsellModal={false} />
                </div>

                <PostalExpand />

                <div className={"text-[11px] font-normal leading-3.5 text-gray-5 text-center px-4"}>
                  *Savings shown relates to tickets in BOTB Pass vs. buying tickets separately. Auto entries only for a
                  part of the competitions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlansModal;
